import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { ENV } from "../config/config";
import { adminLogout } from "../actions/adminAction";

 const useAutoLogout = () => {
    const navigate = useNavigate();
    let inactivityTimer;
  
    const logout = async () => {

      const adminRoleString = localStorage.getItem("adminRole");
      const adminRole = adminRoleString ? JSON.parse(adminRoleString) : null;
    
      if (adminRole?.title === "super admin" || adminRole?.title === "admin") {
        return; 
      }
  
      await adminLogout()
      ENV.logOut();
      navigate("/");
    };
  
    const resetInactivityTimer = () => {
      clearTimeout(inactivityTimer);
      
      inactivityTimer = setTimeout(logout, 30 * 60 * 1000);
    };
  
    useEffect(() => {
      const activityEvents = ["mousedown", "mousemove", "keypress", "scroll", "touchstart"];
      activityEvents.forEach((event) => {
        window.addEventListener(event, resetInactivityTimer);
      });
      resetInactivityTimer();
      return () => {
        activityEvents.forEach((event) => {
          window.removeEventListener(event, resetInactivityTimer);
        });
        clearTimeout(inactivityTimer);
      };
    }, []); 

  };
export default useAutoLogout;